import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "editor-insert-dialog"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Insert options", -1)

import Key from "./Key.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'InsertDialog',
  props: {
  show: {
    type: Boolean,
    required: true
  }
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + H" }, {
              default: _withCtx(() => [
                _createTextVNode("Header")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + P" }, {
              default: _withCtx(() => [
                _createTextVNode("Paragraph")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + Ctrl + N" }, {
              default: _withCtx(() => [
                _createTextVNode("Ordered List")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + Ctrl + U" }, {
              default: _withCtx(() => [
                _createTextVNode("Unordered List")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + Ctrl + C" }, {
              default: _withCtx(() => [
                _createTextVNode("Code")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + M" }, {
              default: _withCtx(() => [
                _createTextVNode("Image")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + B" }, {
              default: _withCtx(() => [
                _createTextVNode("Bold")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + I" }, {
              default: _withCtx(() => [
                _createTextVNode("Italic")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + S" }, {
              default: _withCtx(() => [
                _createTextVNode("Strike")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(Key, { keys: "⌘ + Ctrl + L" }, {
              default: _withCtx(() => [
                _createTextVNode("Link")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, "close")
      ]))
    : _createCommentVNode("", true)
}
}

})